export const nodataPage = [
    `<p>2020年1月20日</p>
    <p>春运开始</p>
    <p class="strong">“家”成了所有人共同的方向</p>
    <p>人潮洋溢幸福</p>
    <p>风雪也变得柔情</p>
    <p>只因路的尽头，有人在守候</p>`,

    `<p>2020注定是不平凡的一年</p>
    <p>春节前夕疫情突发，</p>
    <p>1月23日,武汉封城，</p>
    <p>武汉人民足迹被封锁长达 <span class="bold">76</span> 天</p>
    <p>
      去哪儿除夕夜火车票预订量同比下降<span class="bold">8.07%</span>，
    </p>
    <p>回家团圆之路于风雪间被封印，</p>
    <p>山河遥望仍万众一心。</p>`,

    `<p>2020年2月9日</p>
    <p>全国收假，复工复产</p>
    <p>往日喧嚣的街道恢复车流</p>
    <p>城市的烟火在口罩下重燃</p>
    <p class="strong">自由与希望，伴随城市一同重生</p>`,

    `<p>2020年5月1日</p>
    <p>疫后与世界的第一次重逢</p>
    <p>全民延迟假期，</p>
    <p>多享受几天春日里的暖阳；</p>
    <p>你我共同奔赴爱的方向，</p>
    <p class="strong">分离使人更加懂得陪伴与珍惜。</p>`,
    
    `<p><span class="bold">66.31万</span>人次疫后重游武汉</p>
    <p>奔涌的人流重燃城市烟火，</p>
    <p>向英雄的城市致敬；</p>
    <p>超<span class="bold">6</span> 亿人次在国庆长假选择与世界重逢</p>
    <p>山川不改，此间真情依旧</p>
    <p>疫情让我们更加懂得陪伴与珍惜</p>`,

    `<p>2020年12月，四季轮回，又到年末</p>
    <p>回望2020年这一路走来... ...</p>
    <p>重返武汉，见证城市烟火再起</p>
    <p>遥望西北，追溯北斗发射</p>
    <p>勇攀西藏，脚步丈量珠峰</p>
    <p class="strong">一路见世界,更聆听内心</p>
    <p class="strong">致敬平凡的自己</p>
    <p class="strong">与红旗同行,#旗敬真我#</p>`
]

export const dataPage = [
    `<p>2020年1月20日</p>
    <p>春运开始</p>
    <p class="strong">“家”成了所有人共同的方向</p>
    <p>人潮洋溢幸福</p>
    <p>风雪也变得柔情</p>
    <p>只因路的尽头，有人在守候</p>`,
    
    `<p>2020年1月23日</p>
    <p class="strong">疫情来袭，武汉封城</p>
    <p>新春的主题从“团聚”变作“守望”</p>
    <p>山河遥望，愿故土平安</p>
    <p>英雄远征，盼君早日凯旋归来</p>`,
    
    `<p>2020注定是不平凡的一年</p>
    <p>危难封城, 全民足迹被封锁</p>
    <p>你有<span class="strong">$days</span>天未出门远行</p>
    <p>山河遥望, 心中牵挂愈浓</p>`,

    `<p>2020年2月9日</p>
    <p class="strong">全国收假，复工复产</p>
    <p>往日喧嚣的街道恢复车流</p>
    <p>城市的烟火在口罩下重燃</p>
    <p>自由与希望，伴随城市一同重生</p>`,
    
    `
    <p>春暖花开,与世界的第一次重逢</p>
    <p>2020年<span class="strong">$month</span>月<span class="strong">$day</span>日</p>
    $contentslot
    <p>特别的2020</p>
    <p>更让我们聆听到内心的声音</p>
    <p>敬畏平凡 更懂得珍惜</p>`,

    `<p>2020年10月1日</p>
    <p class="strong">双节黄金周</p>
    <p>国人足迹全面解锁</p>
    <p>向更远更深处探寻</p>
    <p>热情不减畅游大中国</p>`,

    `<p>解禁再出发, 旅行脚步不停</p>
    <p>2020年, 你共出行<span class="strong">$orderNums</span>次,</p>
    <p>累计<span class="strong">$totalDistance</span>航空里程（KM）</p>
    <p>最长一次飞行<span class="strong">$maxHours</span>小时, 穿越<span class="strong">$gongli</span>公里,</p>
    <p>你在<span class="strong">$arrivalCityList</span>留下旅行记忆</p>
    <p>你在旅途中遇见真正的自己</p>
    <p class="strong">2021与红旗同行#旗敬真我#</p>`
]

export const nodataposter = [/* 无数据海报 */
    `<p>2020年，</p>
    <p>一路见世界</p>
    <p>更聆听内心</p>
    <p>致敬平凡的自己</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>分离让我们更加懂得珍惜，</p>
    <p>未来相约一路相伴</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>无数平凡的故事谱写一座座英雄之城，</p>
    <p>敬英雄敬平凡，</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,
]

export const dataposter = [/* 有数据海报 */
    `<p>2020年，</p>
    <p>一路见世界</p>
    <p>更聆听内心</p>
    <p>致敬平凡的自己</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>分离让我们更加懂得珍惜，</p>
    <p>未来相约一路相伴</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>无数平凡的故事谱写一座座英雄之城，</p>
    <p>敬英雄敬平凡，</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>城市的烟火再起，</p>
    <p>生活正在播放，</p>
    <p>未来精彩不停，</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,

    `<p>2020年，</p>
    <p>把不平凡的记忆都化作星光，</p>
    <p>为平凡的生活点亮希望，</p>
    <p>携手红旗<span class="strong">#旗敬真我#</span></p>`,
]